export enum TasksStatusType {
    InProgress = 1,
    Overdue = 2,
    Completed = 3,
    Archived = 4,
}
